<style>
  #map {
    width: 100%;
    max-height: 800px;
    height: 100vh;
  }
</style>

<div id="map"></div>

<script>
  import { onMount } from 'svelte';

  mapboxgl.accessToken = 'pk.eyJ1Ijoibm8wZGxlcyIsImEiOiJjanZ6azYwZ2wwMTV6NDNwbG85aTRiYzQwIn0.7W2rNz3wTDwX_1kzkC988w';

  onMount(async () => {

    const size = 200;
    const pulsingDot = {
      width: size,
      height: size,
      data: new Uint8Array(size * size * 4),

      onAdd: function () {
        const canvas = document.createElement('canvas');
        canvas.width = this.width;
        canvas.height = this.height;
        this.context = canvas.getContext('2d');
      },

      render: function () {
        const duration = 1000;
        const t = (performance.now() % duration) / duration;

        const radius = size / 2 * 0.3;
        const outerRadius = size / 2 * 0.7 * t + radius;
        const context = this.context;

        // draw outer circle
        context.clearRect(0, 0, this.width, this.height);
        context.beginPath();
        context.arc(this.width / 2, this.height / 2, outerRadius, 0, Math.PI * 2);
        context.fillStyle = 'rgba(255, 200, 200,' + (1 - t) + ')';
        context.fill();

        // draw inner circle
        context.beginPath();
        context.arc(this.width / 2, this.height / 2, radius, 0, Math.PI * 2);
        context.fillStyle = 'rgba(255, 100, 100, 1)';
        context.strokeStyle = 'white';
        context.lineWidth = 2 + 4 * (1 - t);
        context.fill();
        context.stroke();

        // update this image's data with data from the canvas
        this.data = context.getImageData(0, 0, this.width, this.height).data;

        // keep the map repainting
        map.triggerRepaint();

        // return `true` to let the map know that the image was updated
        return true;
      }
    };

    const map = new mapboxgl.Map({
      container: 'map',
      style: 'mapbox://styles/mapbox/streets-v11',
      zoom: 14,
      center: [8.5563795, 47.3700309]
    });
    map.addControl(new mapboxgl.NavigationControl());
    map.scrollZoom.disable();

    if (map.tap) {
      map.tap.disable();
    }

    map.on('load', function () {
      map.addImage('pulsing-dot', pulsingDot, {pixelRatio: 2});
      map.addLayer({
        "id": "points",
        "type": "symbol",
        "source": {
          "type": "geojson",
          "data": {
            "type": "FeatureCollection",
            "features": [{
              "type": "Feature",
              "geometry": {
                "type": "Point",
                "coordinates": [8.556958, 47.370019]
              }
            }]
          }
        },
        "layout": {
          "icon-image": "pulsing-dot"
        }
      });
    });
  });
</script>
